import { createContext, useState, useEffect, useContext } from 'react'

const WalletContext = createContext({})

function WalletProvider ({ children }) {
  const [wallet, setWallet] = useState({})

  // On wallet load
  // useEffect(() => {

  // }, [])

  // On wallet change
  // useEffect(() => {

  // }, [wallet])

  return (
    <WalletContext.Provider value={{ wallet, setWallet }}>
      {children}
    </WalletContext.Provider>
  )
}

function useWallet () {
  const context = useContext(WalletContext)
  // if (context === {}) {
  //   throw new Error('useWallet must be used within a WalletProvider')
  // }
  return context
}

export { WalletProvider, useWallet }
